import { type RoomRateEgsPlan, isApplicable, isWaitingOnGate } from './buildEgsApplyPlan';

export type EgsRowStatus = 'blocked' | 'needsDecision' | 'noChange' | 'willChange';

// A room rate waiting on a gate also has a blocker set, so the gate has to be checked first.
export function getEgsRowStatus(plan: RoomRateEgsPlan): EgsRowStatus {
  if (isWaitingOnGate(plan)) {
    return 'needsDecision';
  }

  if (plan.blocker) {
    return 'blocked';
  }

  return isApplicable(plan) ? 'willChange' : 'noChange';
}

// Anything the CM can act on sorts to the top, so a long list does not have to be searched.
const STATUS_SORT_ORDER: Record<EgsRowStatus, number> = {
  needsDecision: 0,
  blocked: 1,
  willChange: 2,
  noChange: 3,
};

export function compareEgsRowStatus(a: EgsRowStatus, b: EgsRowStatus) {
  return STATUS_SORT_ORDER[a] - STATUS_SORT_ORDER[b];
}

function needsEgsAttention(status: EgsRowStatus) {
  return status === 'needsDecision' || status === 'blocked';
}

// Rows only open themselves while the list is short enough to stay navigable.
const MAX_EXPANDED_ROWS = 3;
const MAX_EXPANDED_ATTENTION_ROWS = 5;

export function isEgsRowDefaultExpanded(status: EgsRowStatus, visibleRowCount: number): boolean {
  const limit = needsEgsAttention(status) ? MAX_EXPANDED_ATTENTION_ROWS : MAX_EXPANDED_ROWS;

  return visibleRowCount <= limit;
}
